import { AppData } from '../models/appdata'
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, retry } from 'rxjs/operators';
//import 'rxjs/add/operator/retry';
import { Router } from '@angular/router';
import { ApiResponseModel } from '../models/api_response_model';
import {  ActorImageRequest, ActorDocRequest, ActorDocRequestByType } from '../models/actor/actor';
import { ApiRequestModel } from '../models/api_request_model';
import {
  DownloadFileRequest, DocRenewConfigRequest, ActorDocRenewAlertsRequest,
  ActorDocVerTrackRequest,InitiateActorDocVerificationRequest, ActorDocVerTrackInfoByDocCodeRequest
} from '../models/docs/doc.model';





@Injectable()
export class DOCService {


  constructor(private http: HttpClient,  private router: Router) {


  }
 
  xUploadActorImage(formData, AddActorImageRequest: ActorImageRequest) {
    //console.log('apicall');
    return this.http.post(`${AppData.GlobalApiUrl}Doc/xUploadActorImage`, (formData),
      //  {
      //  formData
      //   AddActorImageRequest
      //},
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
          .set('ActorImageCode', AddActorImageRequest.ActorImageCode.toString())
          .set('xRequestType', AddActorImageRequest.SendApiRequestModel.xRequestType.toString())
          .set('FileExtension', AddActorImageRequest.FileExtension)
          .set('xUserName', AddActorImageRequest.SendApiRequestModel.xUserName),
      }
    ).pipe(catchError(this.handleError));

  }

  //////////////////////
  xUploadActorDocs(formData, AddActorDocRequest: ActorDocRequest) {
    //console.log('apicall');
    return this.http.post(`${AppData.GlobalApiUrl}Doc/xUploadActorDocs`, (formData),
      //  {
      //  formData
      //   AddActorImageRequest
      //},
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
          .set('ConditionalOperator', AddActorDocRequest.ConditionalOperator.toString())
          .set('ActorDocCode', AddActorDocRequest.ActorDocCode.toString())
          .set('EntryActorCode', AppData.Instance().UserLoginDetails.ActorCode.toString())
          .set('xRequestType', AddActorDocRequest.SendApiRequestModel.xRequestType.toString())
          .set('DocFriendlyName', AddActorDocRequest.DocFriendlyName)
          .set('DocFileExtension', AddActorDocRequest.DocFileExtension)
          .set('xUserName', AddActorDocRequest.SendApiRequestModel.xUserName),
      }
    ).pipe(catchError(this.handleError));

  }
    xUploadActorDocs4(formData, AddActorDocRequest: ActorDocRequest) {
      //  alert("in xUploadActorDocs4");
        //console.log('apicall');
        return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}Doc/xUploadActorDocs4`, (formData),
            //  {
            //  formData
            //   AddActorImageRequest
            //},
            {
                headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
                    .set('ConditionalOperator', AddActorDocRequest.ConditionalOperator.toString())
                    .set('ActorDocCode', AddActorDocRequest.ActorDocCode.toString())                  
                    .set('EntryActorCode', AppData.Instance().UserLoginDetails.ActorCode.toString())
                    .set('xRequestType', AddActorDocRequest.SendApiRequestModel.xRequestType.toString())
                    .set('DocFriendlyName', AddActorDocRequest.DocFriendlyName)
                    //.set('DocFileExtension', AddActorDocRequest.DocFileExtension)
                    .set('DocFileExtension', AddActorDocRequest.DocFileExtension)
                    .set('ActorCode', AddActorDocRequest.ActorCode.toString())
                    //.set('Category', '')
                    .set('DocType', AddActorDocRequest.DocType)
                    .set('DocTitle', AddActorDocRequest.DocTitle)
                    .set('DocumentType', AddActorDocRequest.DocType)
                    .set('xUserName', AddActorDocRequest.SendApiRequestModel.xUserName)
            }
        ).pipe(catchError(this.handleError));

    }


  /////////////////
  GetActorDocController(SendActorDocRequest: ActorDocRequest) {

    console.log('SendActorDocRequest-->' + SendActorDocRequest.ActorDocCode);

    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}Doc/GetActorDoc`, (SendActorDocRequest),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(catchError(this.handleError));
  }

  /////////////////
  GetActorDocByTypeController(SendActorDocRequest: ActorDocRequestByType) {

    //console.log('SendActorDocRequest-->' + SendActorDocRequest.ActorDocCode);

    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}Doc/GetActorDocByType`, (SendActorDocRequest),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(catchError(this.handleError));
  }
  ///////////////////////
  xDownloadDoc(SendReqDownloadFileRequestRequest: DownloadFileRequest) {

   return this.http.post(`${AppData.GlobalApiUrl}Doc/xDownloadDoc`, SendReqDownloadFileRequestRequest, {
     headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
     , responseType: "arraybuffer"
   })
     //.map((res: Response) => res.arrayBuffer)
      .subscribe((result) => {
        var filename = Headers['x-filename'];
        console.log('filename-->' + filename);
        var contentType = Headers['content-type'];
        var blob = new Blob([result], {
          type: "application/octet-stream"
        });
        var linkElement = document.createElement('a');
        if ((navigator as any).msSaveBlob) { // IE 10+
          var DownLoadDate = new Date();
          (navigator as any).msSaveBlob(blob, SendReqDownloadFileRequestRequest.FriendlyFileName.concat(DownLoadDate.toDateString()).concat(SendReqDownloadFileRequestRequest.FileExtension))
        }
        else
        {
          var url = window.URL.createObjectURL(blob);

          linkElement.setAttribute('href', url);

          linkElement.setAttribute("download", SendReqDownloadFileRequestRequest.FriendlyFileName.concat(SendReqDownloadFileRequestRequest.FileExtension));



          //var clickEvent = new MouseEvent("click", {

          //  "view": window,

          //  "bubbles": true,

          //  "cancelable": false

          //});

          //linkElement.dispatchEvent(clickEvent);

          document.body.appendChild(linkElement);
          linkElement.click();
          document.body.removeChild(linkElement);

        }


      }
      ,

      (error) => {

        alert('error---------------' + error.message);
      }
      );
  }

  /////////////////
  SaveActorDocs(SendActorDocRequest: ActorDocRequest) {
    //SendActorIdentitiesRequest.ConditionalOperator = 1;
    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}Doc/SaveActorDocs`, (SendActorDocRequest),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(catchError(this.handleError));
  }
  //
  SaveDocRenewConfig(SendDocRenewConfigRequest: DocRenewConfigRequest) {
    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}Doc/SaveDocRenewConfig`, (SendDocRenewConfigRequest),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(catchError(this.handleError));
  }

  GetDocRenewConfigInfoController(SendDocRenewConfigRequest: DocRenewConfigRequest) {

 
    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}Doc/GetDocRenewConfigInfo`, (SendDocRenewConfigRequest),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(catchError(this.handleError));
  }

  GetActorDocRenewAlertsInfoController(SendActorDocRenewAlertsRequest: ActorDocRenewAlertsRequest) {


    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}Doc/GetActorDocRenewAlertsInfo`, (SendActorDocRenewAlertsRequest),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(catchError(this.handleError));
  }

  //
  //------------------------------------------------------
  XInitiateActorDocVerification(SendInitiateActorDocVerificationRequest: InitiateActorDocVerificationRequest) {

    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}Doc/XInitiateActorDocVerification`, (SendInitiateActorDocVerificationRequest),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(catchError(this.handleError));
  }

  //-------------------------
  GetActorDocVerTrackInfoByDocCodeController(SendActorDocVerTrackInfoByDocCodeRequest: ActorDocVerTrackInfoByDocCodeRequest) {

    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}Doc/GetActorDocVerTrackInfoByDocCode`, (SendActorDocVerTrackInfoByDocCodeRequest),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(catchError(this.handleError));
  }
  //
  SaveActorDocVerTrackInfo(SendActorDocVerTrackRequest: ActorDocVerTrackRequest) {

    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}Doc/SaveActorDocVerTrackInfo`, (SendActorDocVerTrackRequest),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(catchError(this.handleError));
  }




  private handleError(error: any) {


    if (error.status === 400) {

      return Promise.reject('Request Failed Due to Bad Request..!');
    }
    //else if (error.status === 401) {
    //  return this.unauthorised();
    //  //return Promise.reject('UnAuthorised Request..!');

    //}
    else if (error.status === 401) {

      //  this.router.navigate(['login']);;;
      //return this.unauthorised();
      return Promise.reject('401 - Unauthorized');

    }
    else if (error.status === -1212401) {

      //  this.router.navigate(['login']);;;
      return this.unauthorised();
      //return Promise.reject('UnAuthorised Request..!');

    }
    else if (error.status === 500) {
      return Promise.reject('Internal Server Error..!');

    }
    else if (error.status === 415) {

      return Promise.reject('Request Failed Due to Unsupported Media Type..!');
    }
    else if (error.status === 404) {
      return Promise.reject('Page Not Found..!');

    }
    else {


      let errMsg = (error.message) ? error.message :
        error.status ? `${error.status} - ${error.statusText}` : 'Server error';
      return Promise.reject(error.message || error);
    }
  }
  unauthorised(): Observable<any> {

    this.router.navigate(['signinpage']);
    return throwError(() => ({}));
  }

}
